/* eslint-disable react/prop-types */
import React from "react";
import { useSelector } from "react-redux";
import { Box, makeStyles } from "@material-ui/core";
import { AiOutlineCalendar } from "react-icons/ai";
import FiltersSelectComponent from "app/filters/FiltersSelectComponent";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "10px",
    borderBottom: "1px solid #e2e2e2",
    display: "flex",
    [theme.breakpoints.up("xs")]: {
      flexDirection: "column",
    },
    [theme.breakpoints.up("lg")]: {
      flexDirection: "row",
      justifyContent: "space-between",
    },
  },
  formControl: {
    margin: theme.spacing(1),
    width: "15ch",
  },
  filtersFormGroup: {
    display: "flex",
    [theme.breakpoints.up("xs")]: {
      flexDirection: "column",
      marginTop: "10px",
      "& > *": {
        marginBottom: "10px",
      },
    },
    [theme.breakpoints.up("lg")]: {
      marginTop: "0px",
      justifyContent: "flex-end",
      flexDirection: "row",
      "& > *": {
        marginBottom: "0px",
        marginLeft: "20px",
        width: "250px",
      },
    },
    // [theme.breakpoints.up("md")]: {
    //   flexDirection: "row",
    //   justifyContent: "flex-end",
    // },
  },
  cycleSelect: {
    [theme.breakpoints.up("lg")]: {
      width: "250px",
    },
  },
}));

export default function ScenarioMapFiltersComponent({ cycle, setCycle }) {
  const classes = useStyles();
  const cycleSlice = useSelector((state) => state.cycle);

  const handleCycleChange = (cycleObject) => {
    setCycle(cycleObject.cycle);
  };

  return (
    <div className={classes.root}>
      <Box component="div" className={classes.cycleSelect}>
        <FiltersSelectComponent
          inputData={{
            key: "cycle",
            label: "Cycle",
            type: "normal",
            data: cycleSlice.list,
            icon: <AiOutlineCalendar size={22} />,
          }}
          small
          required
          filters={{ cycle: { ...cycle } }}
          handleChange={handleCycleChange}
        />
      </Box>
    </div>
  );
}
